import React from 'react';
import { connect } from 'react-redux';
import classes from './CommonOption.scss';
import { setBankOptions } from '../../../../store/actions/index';

const commonOption = (props) => (
    <div onClick={ () => {
            props.onSetBankOptions(props.name);
            props.change({ value: props.code, label: props.name });
        }} className={[classes.OptionContainer, props.bankOption === props.name ? classes.OptionContainerActive : null].join(' ')}>
        <button className={classes.OptionBtn}>{props.children}</button>
        <p>{props.name}</p>
    </div>
);

const mapStateToProps = state => {
    return {
        bankOption: state.ui.bankOption
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetBankOptions: (option) => dispatch(setBankOptions(option))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(commonOption);


// WEBPACK FOOTER //
// ./src/components/Payment/Common/CommonOption/CommonOption.js